<template>
  <div v-if="isAvailable()" :class="{'active-box': isActive()}">
    <router-link
      :to="{name: `adminresponses`, params: {formid: form.FormID, form}}"
      class="form-preview"
      :class="classObject()"
    >
      <div class="form-year">{{schoolYear()}}</div>
      <div class="form-period">{{periodMap[form.Period].deAbreviated}}</div>
      <hr />
      <div class="form-description">{{formDescription()}}</div>
      <div class="response-summary-container" :style="responseContainerStyle()">
        <p
          class="response-summary"
          :style="responseSummaryStyle()"
        >{{Number(form.EmplFormComplPercent * 100).toFixed(0)}}% of your teachers completed this</p>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      periodMap: {
        EOY: { deAbreviated: "End of Year", short: "end" },
        MOY: { deAbreviated: "Middle of Year", short: "middle" },
        BOY: { deAbreviated: "Beginning of Year", short: "beginning" }
      }
    };
  },
  methods: {
    schoolYear() {
      return `${this.form.FiscalYear - 1} - ${this.form.FiscalYear}`;
    },
    classObject() {
      return {
        "eoy-form": this.form.Period === "EOY",
        "moy-form": this.form.Period === "MOY",
        "boy-form": this.form.Period === "BOY"
      };
    },
    responseContainerStyle() {
      return `background: linear-gradient(to right,#9fc277 0%,#9fc277 ${Number(
        this.form.EmplFormComplPercent * 100
      ).toFixed(0)}%,#d8d8d8 ${Number(
        this.form.EmplFormComplPercent * 100
      ).toFixed(0)}%,#d8d8d8 100%)`;
    },
    responseSummaryStyle() {
      return `background: linear-gradient(to right,#ffffff 0%,#ffffff ${Number(
        this.form.EmplFormComplPercent * 100
      ).toFixed(0)}%,#050505 ${Number(
        this.form.EmplFormComplPercent * 100
      ).toFixed(
        0
      )}%,#050505 100%); -webkit-text-fill-color: transparent; -webkit-background-clip: text;`;
    },
    isActive() {
      const now = new Date().getTime();
      return (
        now <= new Date(this.form.CloseWindow.slice(0, 10)).getTime() &&
        now >= new Date(this.form.OpenWindow.slice(0, 10)).getTime()
      );
    },
    isAvailable() {
      return new Date(this.form.OpenWindow).getTime() <= new Date().getTime();
    },
    displayEndDate() {
      return new Date(this.form.CloseWindow.slice(0, 10)).toDateString();
    },
    formDescription() {
      return this.isActive()
        ? `This form is currently active and teachers are filling it out until ${this.displayEndDate()}`
        : `This is the form your teachers filled out in the ${this.periodMap[this.form.Period].short} of the ${this.form.FiscalYear} school year.`;
    }
  }
};
</script>

<style scoped>
div {
  font-family: Arial;
}
.active-box {
  border: 4px solid;
  margin: 0.5em;
}
.form-year {
  font-size: 1.5em;
  color: #ffffff;
  margin: 10px 32px 0px 32px;
}
.form-period {
  min-width: 50px;
  max-width: 105px;
  font-size: 1.5em;
  font-weight: bold;
  color: #ffffff;
  margin: 8px 0px 25.5px 0px;
}
.form-preview {
  width: 17em;
  height: 25em;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 14px 15px 14px 15px;
  text-decoration: none;
}
hr {
  width: 100%;
  height: 1px;
  border: solid 1px #ffffff;
}
.form-description {
  margin: 14.5px 15px 0px 15px;
  min-width: 120px;
  min-height: 56px;
  font-family: Arial;
  font-size: 1em;
  text-align: justify;
  color: #ffffff;
}
.response-summary-container {
  margin-bottom: 4px;
  margin-top: 86px;
  width: 100%;
}
.response-summary {
  font-size: 1em;
  width: 100%;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.95em;
}
.eoy-form {
  background-color: #257d8c;
}
.moy-form {
  background-color: #ae6401;
}
.boy-form {
  background-color: #5d4761;
}
</style>